export default {
    "required": "{label}不得为空",
    "filled": "{label}不得为空",
    "notEmpty": "{label}不得为空",
    "empty": "{label}必须为空",
    "minLength": "不得少于{0}个字符",
    "maxLength": "不得超过{0}个字符",
    "rangeLength": "请输入{0}-{1}个字符",
    "min": "不能小于{0}",
    "max": "不能大于{0}",
    "range": "范围在{0}-{1}之间",
    "pattern": "{label}格式不正确",
    "is": "必须与{0}相同",
    "isNot": "必须与{0}不同",
    "equals": "必须等于{0}",
    "notEquals": "必须不等于{0}",
    "confirmed": "两次输入的密码不一致",
    "includes": "必须包含{args}",
    "excludes": "不能包含{args}",
    "included": "必须为{args}中的值",
    "excluded": "不能为{args}中的值",
    "unique": "该{label}已经存在",
    "noDuplicates": "不能出现重复项",
    "string": "请输入字符串",
    "number": "请输入数字",
    "numeric": "请输入数字",
    "integer": "请输入整数",
    "decimal": "请输入正确格式的小数",
    "boolean": "必须为布尔类型",
    "function": "必须为函数",
    "object": "必须为对象",
    "plainObject": "必须为简单对象",
    "array": "必须为数组",
    "alpha": "请输入字母",
    "alphaNum": "请输入字母或数字",
    "alphaDash": "请输入字母或下划线",
    "alphaNumDash": "请输入字母、数字或下划线",
    "alphaSpaces": "以字母或空格组成",
    "lowerCase": "不能出现大写字母",
    "upperCase": "不能出现小写字母",
    "^az": "以小写字母开头",
    "^az09": "以小写字母或数字开头",
    "^az09_": "以小写字母、数字或下划线开头",
    "^azAZ": "以字母开头",
    "^azAZ09": "以字母或数字开头",
    "^azAZ09_": "以字母、数字或下划线开头",
    "az09$": "以小写字母或数字结尾",
    "azAZ09$": "以字母或数字结尾",
    "^09$": "以数字组成",
    "^az09$": "以小写字母或数字组成",
    "^az09-$": "以小写字母、数字或中划线组成",
    "^az09-.$": "以小写字母、数字、'-'或'.'组成",
    "^azAZ09$": "以字母或数字组成",
    "^azAZ09-$": "以字母、数字或'-'组成",
    "^azAZ09_$": "以字母、数字或'_'组成",
    "^azAZ09-_$": "以字母、数字、'-'或'_'组成",
    "without--": "不能连续出现中划线",
    "without__": "不能连续出现下划线",
    "email": "请输入正确的邮箱",
    "ip": "请输入正确的 IP",
    "ipRange": "请输入正确的 IP 段",
    "port": "请输入正确的端口",
    "url": "请输入正确的 URL",
    "macAddress": "请输入正确的 MAC 地址",
    "md5": "请输入正确的 MD5",
    "ascii": "必须为 ASCII",
    "base32": "必须为 base32 编码",
    "base64": "必须为 base64 编码",
    "byteLength": "字节长度不在指定范围内",
    "dataURI": "必须为 DataURI 编码",
    "magnetURI": "必须为 MagnetURI 编码",
    "divisibleBy": "必须被{0}整除",
    "fullWidth": "必须输入全角字符",
    "halfWidth": "必须输入半角字符",
    "hash": "哈希编码不符合{0}算法",
    "hexColor": "请输入合法的十六进制颜色值",
    "hex": "请输入十六进制数",
    "identityCard": "请输入合法的身份证号码",
    "creditCard": "请输入合法的信用卡号",
    "fqdn": "请输入合法的全限定域名",
    "ipOrFQDN": "请输入一个合法 IP 或全限定域名",
    "isbn": "必须为合法的国际标准书号",
    "issn": "必须为合法的国际标准连续出版物编号",
    "isin": "必须为合法的国际证券识别码",
    "iso8601": "必须为合法的 ISO8601 日期格式",
    "rfc3339": "必须为合法的 RFC3339 日期格式",
    "iso31661Alpha2": "必须为合法的 ISO 3166-1 Alpha-2 国家代码",
    "iso31661Alpha3": "必须为合法的 ISO 3166-1 Alpha-3 国家代码",
    "json": "必须为 JSON 格式字符串",
    "jwt": "必须为合法的 JSON Web Token",
    "latLong": "请输入合法的经纬度坐标，如 (-17.738223, 85.605469)",
    "mobile": "请输入合法的手机号码",
    "mongoId": "请输入合法的 MongoDB 对象 ID",
    "postalCode": "请输入合法的邮政编码",
    "uuid": "请输入合法的 UUID",
    "chinese": "请输入中文内容"
};
//# sourceMappingURL=zh-CN.js.map